import { useTranslations } from 'next-intl';

import { type DashboardV2ComparisonMode } from '../../generated/graphql';

export type RevenueChartComparisonOption =
  | DashboardV2ComparisonMode.PreviousPeriod
  | DashboardV2ComparisonMode.PreviousYear;

export function useFormatRevenueChartComparison(): (comparisonMode: RevenueChartComparisonOption) => string {
  const t = useTranslations('charts.filters.comparison.options');

  return (comparisonMode) => t(comparisonMode);
}
